import axios from 'axios';

export const API_BASE = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${API_BASE}/api`,
  withCredentials: true,
});

// Response interceptor — redirect to login on 401
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const publicPaths = ['/', '/privacy', '/reset-password', '/verify-email', '/unsubscribe', '/account-deleted'];
      const isSharedPage = path.startsWith('/shared/');

      if (!publicPaths.includes(path) && !isSharedPage) {
        window.location.href = '/';
      }
    }
    return Promise.reject(error);
  }
);

export default api;
